export default "__VITE_ASSET__aVwvO7ga__"